import React, { useEffect,useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { initialFormData, initialErrors, fieldValidation  } from '../../../common/helper/form-constants.js';
import { MESSAGES } from '../../../constants/constants.js';

const ConfirmKey = (props) => {
  const [formData, setFormData] = useState({key_id:'', secret: ''});
  const [errors, setErrors] = useState({ ...initialErrors });
  const [selectedOption, setSelectedOption] = useState('immediately');
  const generateRandomString = (number) => {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    const charactersLength = characters.length;
    for (let i = 0; i < number; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  const handleChange = (e) => {
 

    setSelectedOption(event.target.value);
    
    const { name, value } = e.target;
    
    if(selectedOption !='immediately') {
     
      setFormData((prevData) => ({ ...prevData, [name]: value }));
      validateField(name, value);
    }
  };

  const validateField = (fieldName, value) => {
    const errorMessage = fieldValidation(fieldName, value);
    setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: errorMessage }));
    console.log(errorMessage)
    return errorMessage
  };

  const onSave = (e) => {
   console.log(selectedOption)
    e.preventDefault();
    if(selectedOption !='immediately') {
      let hasErrors;
      Object.keys(formData).forEach(fieldName => {
        const error = validateField(fieldName, formData[fieldName]);
        if (error) {
            hasErrors = true;
        }
    });
    if(!hasErrors) {
      if(selectedOption =='immediately') {
        formData.activate_in_hour = '';
      }
      props.onSubmit(formData);
    }
  } else  {
    props.onSubmit(formData);
  }
}
  useEffect(() => {

        setFormData({
         // key_id: generateRandomString(15),
          secret: generateRandomString(25),
          activate_in_hour: '24'
        })

      }, []); 

      const downloadKeys = () => {
        let row = {
          secret: formData.secret
        }
        const csvData = [
          Object.keys(row).join(','), // Headers
            Object.values(row).join(',') // Values
        ].join('\n');
        const blob = new Blob([csvData], { type: 'text/csv' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'keys.csv';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      }

    return (
      <>
       <Modal  {...props}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm and deactivate current key? </Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <p style={{textAlign: 'left', fontSize: '16px'}}>This is required to get a new key</p>
        <form action="#" method="post">
          <div className="form-group" style={{textAlign: 'left', marginBottom: '5px'}}>
            <input type="radio" value = "immediately" id="test1" name="radio-group" onChange={handleChange}  checked={selectedOption === 'immediately'}/>
            <label style={{fontWeight: 500, fontSize: '15px'}} htmlFor="test1">Deactivate old key immediately</label>
          </div>
          {/* <div className="form-group" style={{textAlign: 'left', marginBottom: '5px'}}>
            <input type="radio" id="test2" onChange={handleChange} name="radio-group"  checked={selectedOption !== 'immediately'}/>
            <label className="labs" style={{fontWeight: 500, fontSize: '15px'}} htmlFor="test2">Deactivate old key in <input className={`houinput ${errors.activate_in_hour ? 'is-invalid' : ''}`}   onChange={handleChange} name ="activate_in_hour" type="number" value={formData.activate_in_hour} maxLength={2}/> hours </label>
            {errors.activate_in_hour && <div className="invalid-feedback">{errors.activate_in_hour}</div>}
          </div> */}

          <div className="form-group" style={{textAlign: 'left'}}>
          <label htmlFor="keysecret">Key Secret</label>
          <input type="text" className="form-control" value={formData.secret} id="key_secret" disabled/>
          <button type='button'  onClick={downloadKeys} className="btn btn-success ddfg modal__button regentrae-key" id="open-modalg" style={{color: '#3280dd!important', backgroundColor: 'white!important', marginTop:'10px', border: '1px solid #65c5ff', fontSize: '12px'}}>
            <i className="fa fa-download" style={{color: '#3280dd', marginRight: '7px'}} />Download</button>
        </div>
        
        </form>
      
            
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={props.onHide}>
            Close
          </Button>
          <Button variant="primary" onClick={onSave}>
          Confirm and deactivate
          </Button>
        </Modal.Footer>
      </Modal>
      </>
    );
  }
  


  export default ConfirmKey;



